import * as React from 'react';

import { SelectOption as Props } from './select-option.types';

/** This component is not intended to be used directly. It is used by `Select` internally */
const SelectOption: React.FunctionComponent<Props> = ({
  value,
  text,
  ...rest
}) => (
  <option value={value} {...rest}>
    {text}
  </option>
);

export default SelectOption;
